"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createVisibilityPropsSDKFactory = void 0;
const composeSDKFactories_1 = require("../composeSDKFactories");
const hiddenCollapsedSDKFactory_1 = require("./hiddenCollapsedSDKFactory");
const viewportPropsSDKFactory_1 = require("./viewportPropsSDKFactory");
const visibilityPropsSDKFactory = (api, hasPortal = false) => {
    const [state, setState] = api.createSdkState({
        onViewportEnter: [],
        onViewportLeave: [],
    }, 'viewport');
    const registerCallback = (type, callback) => {
        setState({ [type]: [...state[type], callback] });
    };
    const hiddenCollapsedSDKFactory = (0, hiddenCollapsedSDKFactory_1.createHiddenCollapsedSDKFactory)({
        viewportState: state,
        hasPortal,
    });
    const viewportPropsSDKFactory = (0, viewportPropsSDKFactory_1.createViewportPropsSDKFactory)(registerCallback);
    return (0, composeSDKFactories_1.composeSDKFactories)(hiddenCollapsedSDKFactory, viewportPropsSDKFactory)(api);
};
const createVisibilityPropsSDKFactory = (hasPortal) => {
    return (api) => visibilityPropsSDKFactory(api, hasPortal);
};
exports.createVisibilityPropsSDKFactory = createVisibilityPropsSDKFactory;
//# sourceMappingURL=visibilityPropsSDKFactory.js.map